import { RecordType } from "src/gqty";
import { z } from "zod";

export const recordTypeSchema = z.enum(RecordType);
